import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { createProperty } from '../api';

/**
 * @param {import('react-query').UseMutationOptions} useMutationOptions
 * @returns {import('react-query').UseMutationResult}
 */
export default function useCreateProperty(useMutationOptions) {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (variables) => dispatch(createProperty(variables)),
    ...useMutationOptions,
  });
}
